<template>
  <MyModal
    height="auto"
    width="420px"
    class="fengji-modal"
    :title="title || '风机'"
    @closeClick="$emit('close')"
  >
    <tower-info :turbine="turbine" :scene="scene"></tower-info>
  </MyModal>
</template>

<script>
import MyModal from './modal.vue';
export default {
  components: {
    MyModal
  },
  props: {
    turbine: {
      type: Object
    },
    scene:{
      type: String
    },
    plan: {
      type: Object
    },
    turbineList: {
      type: Array
    },
    title: {
      type: String,
      default: '风机'
    }
  }
};
</script>

<style lang="less" scoped>
  ::v-deep.wind-farm-modal-wrapper .content{
    overflow-y: auto;
    background-color: transparent;
    padding:0;
  }
.fengji-modal {
  bottom: 25px;
  height: 270px;
  right: 5px;
  top: auto;
  z-index: 1100;
  //background: rgba(255, 255, 255, 0.9);
}
.turbine_wrapper {
  display: flex;
  align-items: center;
  padding: 0 15px;
  margin-top: 20px;
  .turbine-label {
    width: 100px;
  }
  .el-radio {
    margin-right: 10px !important;
  }
}
</style>
